<template>
<div class="white pa-3">
  <v-card class="elevation-1">
    <v-card-title primary-title>
      <span class="title">Validate Results  </span>
    </v-card-title>
    <v-card-text class="pt-0">
        <v-form ref="form" @submit.prevent="submit" lazy-validation>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs2 class="ma-0" v-for="exchange in exchanges" :key="exchange.name" >
                <v-checkbox :label="exchange.name" :value="exchange" v-model="exchangesSelected" color="primary" hide-details class="ma-0" ></v-checkbox>
              </v-flex>
              <v-flex xs12 class="mt-1">
                <v-btn
                  color="primary" 
                  type="submit" 
                  :dark="!(writeSpreadsheet.disabled || writeSpreadsheet.timeout !== 0)" 
                  :loading="writeSpreadsheet.loading || writeSpreadsheet.timeout !== 0" 
                  :disabled="writeSpreadsheet.disabled || writeSpreadsheet.timeout !== 0" >
                  Write Spreadsheet 
                  <span v-if="writeSpreadsheet.timeout !== 0" slot="loader">Refresh in {{ this.writeSpreadsheet.timeout }} seconds</span>
                </v-btn>      
                  <v-btn href='https://docs.google.com/spreadsheets/d/1T_kciH0lIUBlvUORiYxZ4OL49FeyrJTYM6uNwTTqrlc' target="_blank" color='success'>
                    <v-icon left>description</v-icon>
                    <span>go to spreadsheet</span>
                  </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
    </v-card-text>
  </v-card>
</div>
</template>

<script>
  import MongoService from '../../services/mongo.service.js';
  import MessageDialog from '../../libs/message-dialog/'
  const exchanges = [
    { name: 'Bithumb', gid: 434289308 },
    { name: 'Korbit', gid: 367725773 },
    { name: 'Coinone', gid: 1213933395 },
    { name: 'Bittrex', gid: 1783549488 },
    { name: 'Poloniex', gid: 214775946 },
    { name: 'Bitstamp', gid: 1392608794 },
    { name: 'Binance', gid: 1081598575 },
    { name: 'Bitfinex', gid: 943186560 },
    { name: 'Kraken', gid: 0 },
    { name: 'Huobi', gid: 1369103890 },
    { name: 'Okex', gid: 1869645314 },
    { name: 'Hitbtc', gid: 164220818 }
  ]
  export default {
    props: {
      date: { type: String, required: false }
    },
    data () {
      return {
        exchanges,
        exchangesSelected: [],
        loading: false,
        writeSpreadsheet: {
          loading: false,
          disabled: false,
          activated: false,
          timeout: 0
        }
      }
    },
    methods: {
      async submit () {
        if (!this.$refs.form.validate()) return
        this.loading = true
        try {
          if (this.exchangesSelected.length !== 0) {
            const data = await MongoService.sales.validateWithdrawAndDepositResult(this.date, this.exchangesSelected)
            this.setActionTimeout(this.writeSpreadsheet, 60);
            MessageDialog.showSuccessMessage({
              html: `
                <div>Your request has been processed</div>
                <code class="mt-3 pl-3 pr-3 text-xs-left"><pre>date: ${this.date}</pre><pre>exhanges: ${JSON.stringify(this.exchangesSelected)}</pre><pre>response: ${JSON.stringify(data)}</pre></code>
              `
            })
          } else {
            MessageDialog.showErrorMessage({
              html: `
                <div>Please, choose some exchanges.</div>
              `
            })
          }
        } catch (e) {
          MessageDialog.showErrorMessage({ text: e.toString() })
          console.error(e)
        }
        this.loading = false
      },
      async setActionTimeout(action = {}, timeout = 60) {
        return new Promise(resolve => {
          action.timeout = timeout;
          const iInterval = setInterval(() => {
            action.timeout--;
            if (action.timeout <= 0) {
              clearInterval(iInterval);
              resolve();
            }
          }, 1000);
        });
      }
    }
  }
</script>
